const crypto = require('crypto');
const algorithm = 'aes-256-cbc';

export function encrypt(text) {
    const iv = crypto.randomBytes(16);
    const key = crypto.randomBytes(32);
    let cipher = crypto.createCipheriv(algorithm, Buffer.from(key), iv);
    let encrypted = cipher.update(text);
    encrypted = Buffer.concat([encrypted, cipher.final()]);
    return { iv: iv.toString('hex'), encryptedData: encrypted.toString('hex'), key: key.toString('hex') };
}

export function decrypt(message) {
    let iv = Buffer.from(message.iv, 'hex');
    let encryptedText = Buffer.from(message.encryptedData, 'hex');
    let key = Buffer.from(message.key, 'hex');
    let decipher = crypto.createDecipheriv(algorithm, key, iv);
    let decrypted = decipher.update(encryptedText);
    decrypted = Buffer.concat([decrypted, decipher.final()]);
    return decrypted.toString();
}